import { REDEEM_PREPAID_SUBSCRIPTION_REQUEST, REDEEM_PREPAID_SUBSCRIPTION_SUCCESS, REDEEM_PREPAID_SUBSCRIPTION_ERROR, } from '../types';
const redeemPrepaidSubscriptionRequest = (payload) => ({
    type: REDEEM_PREPAID_SUBSCRIPTION_REQUEST,
    payload,
});
const redeemPrepaidSubscriptionError = (error, payload) => ({
    type: REDEEM_PREPAID_SUBSCRIPTION_ERROR,
    payload,
    error,
});
const redeemPrepaidSubscriptionSuccess = (payload, giftCard) => ({
    type: REDEEM_PREPAID_SUBSCRIPTION_SUCCESS,
    payload,
    giftCard,
});
export const redeemPrepaidSubscription = (payload) => async (dispatch, _getState, { chord }) => {
    dispatch(redeemPrepaidSubscriptionRequest(payload));
    try {
        const giftCard = await chord.oms.redeemPrepaidSubscription(payload);
        dispatch(redeemPrepaidSubscriptionSuccess(payload, giftCard));
        return giftCard;
    }
    catch (e) {
        dispatch(redeemPrepaidSubscriptionError(e, payload));
        throw e;
    }
};
